import PropTypes from 'prop-types';
import React from 'react';
import { constructOLSReviewLink, linkOnClickHandler } from '../../../common/navigation/navigation';
import { useAppContext } from '../../../common/contexts/AppContext';
import MeasureScore from '../measure-score/MeasureScore';

const OLSMeasureScore = ({ score, interpretation, studentId, period, classId, resultId, lang }) => {
    const { checkAndGetSessionStatus } = useAppContext();

    const path = constructOLSReviewLink(studentId, {
        period,
        classId,
        lang,
        resultId,
    });
    return (
        <MeasureScore
            score={score}
            interpretation={interpretation}
            path={path}
            onClick={linkOnClickHandler(path, checkAndGetSessionStatus)}
        />
    );
};

OLSMeasureScore.propTypes = {
    score: PropTypes.number,
    interpretation: PropTypes.string,
    studentId: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    classId: PropTypes.string.isRequired,
    resultId: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
};

OLSMeasureScore.defaultProps = {
    score: null,
    interpretation: null,
};

export default OLSMeasureScore;
